import {useState, useEffect} from 'react';
import styled from 'styled-components'
import { getDestaques } from '../../data/About';

const Grid = styled.div`
    @keyframes scale-up{
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.15);
        }
    }

    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 30px;
    
    .item {
        cursor: pointer;
        box-shadow:  5px 5px 20px rgba(0,0,0,0.1), -5px -5px 20px rgba(0,0,0,0.2);
        transition: all ease 0.3s;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .item img {
        height: 100%;
        width: 100%;
    }
    .item:hover {
        animation: scale-up 0.5s ease-in-out forwards;
    }
    
    @media (min-width: 768px) {
        .item {
            width: 40%;
        }
    }

    @media (min-width: 992px) {
        .item {
            width: 30%;
        }
    }

    @media (min-width: 1200px) {
        .item {
            width: 20%;
        }
    }
`;
const Wall = styled.div`
@-webkit-keyframes building-blocks {
	0%,
	20% {
	  opacity: 0;
	  -webkit-transform: translateY(-300%);
			  transform: translateY(-300%); }
	30%,
	70% {
	  opacity: 1;
	  -webkit-transform: translateY(0);
			  transform: translateY(0); }
	90%,
	100% {
	  opacity: 0;
	  -webkit-transform: translateY(300%);
			  transform: translateY(300%); } }
  @keyframes building-blocks {
	0%,
	20% {
	  opacity: 0;
	  -webkit-transform: translateY(-300%);
			  transform: translateY(-300%); }
	30%,
	70% {
	  opacity: 1;
	  -webkit-transform: translateY(0);
			  transform: translateY(0); }
	90%,
	100% {
	  opacity: 0;
	  -webkit-transform: translateY(300%);
			  transform: translateY(300%); } }
  
	position: relative; 
	 div {
	  height: 20px;
	  position: absolute;
	  width: 20px; }
	   div:after {
		-webkit-animation: building-blocks 2.1s ease infinite backwards;
				animation: building-blocks 2.1s ease infinite backwards;
		background: #707070;
		content: '';
		display: block;
		height: 20px;
		width: 20px; }
	   div:nth-child(1) {
		-webkit-transform: translate(-50%, -50%) translate(60%, 120%);
				transform: translate(-50%, -50%) translate(60%, 120%); }
	   div:nth-child(2) {
		-webkit-transform: translate(-50%, -50%) translate(-60%, 120%);
				transform: translate(-50%, -50%) translate(-60%, 120%); }
	   div:nth-child(3) {
		-webkit-transform: translate(-50%, -50%) translate(120%, 0);
				transform: translate(-50%, -50%) translate(120%, 0); }
	   div:nth-child(4) {
		-webkit-transform: translate(-50%, -50%);
				transform: translate(-50%, -50%); }
	   div:nth-child(5) {
		-webkit-transform: translate(-50%, -50%) translate(-120%, 0);
				transform: translate(-50%, -50%) translate(-120%, 0); }
	   div:nth-child(6) {
		-webkit-transform: translate(-50%, -50%) translate(60%, -120%);
				transform: translate(-50%, -50%) translate(60%, -120%); }
	   div:nth-child(7) {
		-webkit-transform: translate(-50%, -50%) translate(-60%, -120%);
				transform: translate(-50%, -50%) translate(-60%, -120%); }
	 div:nth-child(1):after {
	  -webkit-animation-delay: 0.15s;
			  animation-delay: 0.15s; }
	 div:nth-child(2):after {
	  -webkit-animation-delay: 0.3s;
			  animation-delay: 0.3s; }
	 div:nth-child(3):after {
	  -webkit-animation-delay: 0.45s;
			  animation-delay: 0.45s; }
	 div:nth-child(4):after {
	  -webkit-animation-delay: 0.6s;
			  animation-delay: 0.6s; }
	 div:nth-child(5):after {
	  -webkit-animation-delay: 0.75s;
			  animation-delay: 0.75s; }
	 div:nth-child(6):after {
	  -webkit-animation-delay: 0.9s;
			  animation-delay: 0.9s; }
	 div:nth-child(7):after {
	  -webkit-animation-delay: 1.05s;
			  animation-delay: 1.05s; }
`;
type Props = {
    goto(): void;
    list: string[];
    loading: boolean;
}

const DestaquesGrid = ({goto, list, loading} : Props) => {
    if(list.length < 2){
        return (
            <div className='p-4  my-4 d-flex justify-content-center align-items-center'>
                <Wall>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </Wall>
            </div>
        )
    } else {
        return(
            <Grid>
                {list.map((item, key) => (
                    <div className='item' onClick={goto} key={key}>
                        <img src={item} alt="" />
                    </div>
                ))}
            </Grid>
        )
    }
}

export default DestaquesGrid;